import React from "react";
import { Button, TableCell } from "@mui/material";
import { usePhoneMode } from "../../hooks";

export default function FaultNameCell({ faultName, engineeringNames, legacy, onClick }) {
    const { phoneMode } = usePhoneMode();

    let faultNameText = faultName;
    if (legacy) {
        faultNameText = engineeringNames.join(", ");
    }

    return (
        <TableCell style={{ borderBottom: phoneMode ? 'none' : undefined }}>
            {legacy ? (
                <Button onClick={onClick} style={{ textTransform: 'unset' }}>{faultNameText}</Button>
            ) : (
                <span>{faultNameText}</span>
            )}
        </TableCell>
    );
}